import fetchAPI from '../fetchUtils';

const publicAPI = {
  getInvoice: async (token) =>
    fetchAPI.getAnonymous(`/get-public-invoice-details/${token}`),
  getPayment: async (token) =>
    fetchAPI.getAnonymous(`/get-public-payment-details/${token}`),
  getEstimate: async (token) =>
    fetchAPI.getAnonymous(`/get-public-estimate-details/${token}`),
  acceptEstimate: async (id) =>
    fetchAPI.getAnonymous(`/estimates/${id}/accept`),
  declineEstimate: async (id) =>
    fetchAPI.getAnonymous(`/estimates/${id}/decline`),
};

export default publicAPI;
